import { map, take, tap } from 'rxjs/operators'
import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { CompetitionTeam } from './competition-team'
import { CompetitionTeamSerializer } from './competition-team.serializer'
import { Observable, Subject } from 'rxjs'
import { ISO639LanguageCodes } from 'src/app/shared/utils/languageCodes'

@Injectable()
export class CompetitionTeamService extends ResourceService<CompetitionTeam> {
  private idMember$ = new Subject<any>()

  constructor(
    private http: HttpClient,
    private competitionTeamSerializer: CompetitionTeamSerializer
  ) {
    super(
      http,
      `${environment.backendApiUrl}/competition-teams`,
      competitionTeamSerializer
    )
  }

  public updateMemberName(
    idMember: number,
    firstName: string
  ): Observable<any> {
    const json = { firstName, lastName: 'TEAM' }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    })
    const options = { headers: headers }

    return this.http.patch<any>(
      `${environment.backendApiUrl}/members/${idMember}`,
      json,
      options
    )
  }

  public sendInvitationEmail(
    competitionTeam: CompetitionTeam,
    type: string,
    language: ISO639LanguageCodes,
    toEmail: string,
    teamInviteType: string,
    functionId: number,
    competitionId: number,
    number?: number
  ): Observable<any> {
    let link = `${window.location.origin}/pages/register?teamId=${competitionTeam?.id}&teamInviteType=${teamInviteType}&functionId=${functionId}&competitionId=${competitionId}`

    if (number) {
      link += `&number=${number}`
    }

    return this.http.post<any>(
      `${environment.backendApiUrl}/email-templates/task`,
      {
        type,
        language,
        toEmail,
        params: {
          competitionTeam,
          link
        }
      }
    )
  }
}
